/* @jsx h */
import { h, defineComponent } from "vue";

export interface EmptyViewProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export const EmptyView = defineComponent<EmptyViewProps>({
  name: "EmptyView",
  props: ["icon", "title", "description", "actionLabel", "onAction"],
  setup(props) {
    return () => (
      <div class="flex h-80 flex-col items-center justify-center rounded-lg border-2 border-dashed ">
        <span class="material-symbols-outlined mb-4 text-6xl text-base-content/30">
          {props.icon || "inbox"}
        </span>
        <h3 class="mb-2 text-lg font-medium text-base-content">
          {props.title}
        </h3>
        {props.description && (
          <p class="mb-4 text-sm text-base-content/70">{props.description}</p>
        )}
        {props.actionLabel && props.onAction && (
          <button class="btn btn-primary btn-sm" onClick={props.onAction}>
            <span class="material-symbols-outlined">add</span>
            {props.actionLabel}
          </button>
        )}
      </div>
    );
  },
});
